import request from '@/utils/request'

// 获取批量指令记录列表
export const apiBatchCommandRecordsList = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batch/list',
		method: 'POST',
		data,
	})
}

// 查询指令模型视图
export const apiGetCommandList = params => {
	return request({
		url: '/monitor/command/ledger/cmdmodel/list/view',
		method: 'GET',
		params,
		pending: true,
	})
}

export const apiGetCommandRecordList = data => {
	return request({
		url: '/monitor/report/command/list/preview',
		method: 'POST',
		data,
		pending: true,
	})
}

export const apiGetDeviceIotDetails = iotDeviceId => {
	return request({
		url: `/monitor/ledger/device/iotdetail?iotDeviceId=${iotDeviceId}`,
		method: 'GET',
	})
}

// 批量指令下发
export const apiBatchSendCommand = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batch/send',
		method: 'POST',
		data,
		needJointIsolation: true,
	})
}

// 单表指令下发
export const apiOneSendCommand = data => {
	return request({
		url: '/monitor/command/ledger/cmdmodel/send',
		method: 'POST',
		data,
	})
}

export const apiGetCmdModelBatchSendNum = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batch/sendNum',
		method: 'POST',
		data,
	})
}

// 指令执行表具监控
export const apiBatchCommandDetailList = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batch/list/detail',
		method: 'POST',
		data,
	})
}

// 批量指令基本属性
export const apiGetBasicInfo = params => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batch/list/detail/up',
		method: 'GET',
		params,
	})
}

// 批量指令基本属性
export const apiReSend = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batch/resend',
		method: 'POST',
		data,
	})
}

// 批量任务列表查询
export const apiBatchTaskList = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batchTask/list',
		method: 'POST',
		data,
	})
}

// 批量任务列表-导入失败明细
export const apiBatchTaskFailList = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batchTask/failList',
		method: 'POST',
		data,
	})
}

// 批量任务审核列表
export const apiBatchTaskReviewList = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batchTask/reviewList',
		method: 'POST',
		data,
	})
}

// 批量任务审核列表-任务下的设备明细
export const apiBatchTaskDeviceList = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batchTask/review/device',
		method: 'POST',
		data,
	})
}

// 批量任务审核
export const apiBatchTaskReview = data => {
	return request({
		url: '/monitor/command/operation/cmdmodel/batchTask/review',
		method: 'POST',
		data,
	})
}
